import * as React from 'react';
import type {
  ServiceOrderListEntry,
  ServiceOrderIndicators,
} from 'contracts/service-orders';
import { api, applyQueryString } from 'services/api';
import type { Filters } from 'hooks/store/service-orders';

type FetchServiceOrdersResponse = {
  serviceOrders: ServiceOrderListEntry[];
  indicators: ServiceOrderIndicators;
}

type FetchParams = {
  filters?: Filters;
}

export const useFetchServiceOrders = () => {
  const fetchServiceOrders = React.useCallback(async (params?: FetchParams) => {
    const filters = params?.filters ?? {};
    const preparedFilters = prepareQueryObject(filters);

    const url = applyQueryString('/inventory/service-orders', preparedFilters);
    const { data } = await api.get<FetchServiceOrdersResponse>(url);

    return data;
  }, []);

  return {
    fetchServiceOrders,
  };
};

const prepareQueryObject = (filters: Filters) => {
  Object.entries(filters).forEach(([key, value]) => {
    if (!value || (Array.isArray(value) && !value?.length)) {
      delete (filters as Record<string, unknown>)[key];
    }
  });

  return filters;
};
